import { StyleSheet } from 'aphrodite';
import { antiFlashWhite, backgroundAlt, borderColor, grayIconFill, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		border: `1px solid ${borderColor}`,
		borderRadius: 8,
		backgroundColor: white,
		marginBottom: 16,
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '12px 16px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: backgroundAlt,
		},
	},
	headerLeft: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		flex: 1,
		minWidth: 0,
	},
	headerTitle: {
		fontSize: 14,
		fontWeight: 600,
		margin: 0,
	},
	headerBadge: {
		fontSize: 11,
		color: grayIconFill,
		padding: '2px 6px',
		borderRadius: 4,
		backgroundColor: antiFlashWhite,
	},
	chevron: {
		color: grayIconFill,
		flexShrink: 0,
		display: 'inline-flex',
		alignItems: 'center',
	},
	preview: {
		fontSize: 13,
		lineHeight: 1.4,
		color: grayIconFill,
		margin: '4px 0 0',
		display: '-webkit-box' as any,
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical' as any,
		overflow: 'hidden',
	},
	body: {
		padding: '0 16px 16px',
		borderTop: `1px solid ${borderColor}`,
	},
	section: {
		marginTop: 12,
	},
	sectionLabel: {
		fontSize: 12,
		fontWeight: 600,
		textTransform: 'uppercase' as const,
		color: grayIconFill,
		marginBottom: 4,
	},
	accountNotes: {
		fontSize: 13,
		lineHeight: 1.4,
		color: grayIconFill,
		fontStyle: 'italic',
		margin: 0,
		whiteSpace: 'pre-wrap',
	},
	accountNotesHint: {
		fontSize: 12,
		color: grayIconFill,
		marginTop: 4,
	},
	actions: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 8,
		marginTop: 8,
	},
	emptyHint: {
		fontSize: 13,
		color: grayIconFill,
		margin: 0,
	},
	editLink: {
		fontSize: 13,
		padding: 0,
		height: 'auto',
		fontWeight: 500,
		alignSelf: 'flex-start',
	},
});
